import Footer from "../Footer/Footer";
import Header from "../Header/Header";

import BlockContent from "../Block/BlockContent";
import BlockTitle from "../Block/BlockTitle";
import BlockSubtitle from "../Block/BlockSubtitle";
import BlockText from "../Block/BlockText";
import BlockButton from "../Block/BlockButton";
import Block from "../Block/Block";
import { useNavigate } from 'react-router-dom';

function ICIP2026() {
    const navigate = useNavigate();
  return (
    <div>
      <Header/>        

      <div style={{backgroundImage:'url("/Home/pointwave.webp")', 
                  height:"200px",
                  width: "100%",
                  backgroundSize: "100% 100%",
                  backgroundPosition: "bottom"}}>
      </div>

      <Block colorTheme="light" gridTemplateColumns="1200px">
        <BlockContent width="100%">
          <BlockTitle>The Impact of Intrinsic Scene Cues on Perceived Color Transfer Quality</BlockTitle>
          <BlockSubtitle>IEEE International Conference on Image Processing (ICIP), Tampere, Finland, Sep. 13 - 17, 2026.</BlockSubtitle>
          <BlockText>Herbert Potechius, Thomas Sikora, Sebastian Knorr</BlockText>
        </BlockContent>
      </Block>

      <Block colorTheme="dark" gridTemplateColumns="1200px">
        <BlockContent width="100%">
            <BlockSubtitle>Abstract</BlockSubtitle>
            <BlockText>Color transfer adjusts the colors of a source image to match the color characteristics of a reference image, often for artistic or visual enhancement purposes. While most existing methods operate purely on color statistics, the influence of intrinsic scene cues on perceptual quality remains underexplored. This paper investigates the impact of incorporating semantics, illumination, and geometry into color transfer algorithms. To enable this analysis, we introduce a dataset of photorealistic indoor scenes rendered with controlled variations in viewpoint, object arrangement, illumination, and color distribution. Each scene includes intrinsic scene representations capturing illumination, semantic, and geometric properties. A modular framework is proposed to integrate this information into existing methods. Subjective user studies show that intrinsic scene cues significantly influence perceived color transfer quality.</BlockText>
        </BlockContent>
      </Block>

      <Block colorTheme="light" gridTemplateColumns="240px 240px 240px 240px 240px">
        <BlockContent textAlign="center" width="10%" color="grey" fontStyle="italic">
          <BlockButton disabled onClick={() => window.open("https://dl.acm.org/doi/10.1145/3697294.3697308")}>Paper</BlockButton>
        </BlockContent>
        <BlockContent textAlign="center" width="10%" color="grey" fontStyle="italic">
          <BlockButton disabled onClick={() => window.open("https://dl.acm.org/doi/10.1145/3697294.3697308")}>arXiv</BlockButton>
        </BlockContent>
        <BlockContent textAlign="center" color="grey" fontStyle="italic">
          <BlockButton onClick={() => window.open("https://potechius.com/ICIP2026ColorTransfer/")}>Suppl.</BlockButton>
        </BlockContent>
        <BlockContent textAlign="center" color="grey" fontStyle="italic">
          <BlockButton onClick={() => window.open("https://github.com/hpotechius/CueAwareColorTransfer")}>Code</BlockButton>
        </BlockContent>
        <BlockContent textAlign="center" color="grey" fontStyle="italic">
          <BlockButton onClick={() => navigate("/Projects/Datasets/IDD")}>Dataset</BlockButton>
        </BlockContent>
        {/* <BlockContent textAlign="center" color="grey" fontStyle="italic">
          <BlockButton disabled onClick={() => navigate('/Projects/Datasets/CTPublication')}>Code</BlockButton>
        </BlockContent> */}
      </Block>



      <Footer/>
    </div>
  );
}

export default ICIP2026;
